import { ReferenceFieldRowFormat } from './reference-field-row-format.interface';
import { SubForm } from './sub-form.interface';

export class ReferenceField {
  id: number | string;
  dataViewColumn: string;
  sortByValue: any;
  rowFormat: ReferenceFieldRowFormat;
  subForm?: SubForm;
  disabled?: boolean;
}

export function isReferenceField(value: any): boolean {
  return value && typeof value === 'object' && 'id' in value && 'dataViewColumn' in value;
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/interfaces/reference-field.interface.ts